import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import CastingServices from "../../../services/CastingService";
import Swal from "sweetalert2";

const CastingDigital = () => {
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [formNumber, setFormNumber] = useState("");
    const [requestType, setRequestType] = useState("mrv");
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [headindData, setHeadingData] = useState('')

    const handleSearch = async () => {
        if (!formNumber) {
            Swal.fire("Error", "Please enter form number", "error");
            return;
        }

        setReportData([]);
        setLoading(true);

        try {
            const res = await CastingServices.CastingDigitalReport({
                no: formNumber,
                type: requestType,
            });

            const responseData = Array.isArray(res?.data) ? res.data : [];
            setHeadingData(res?.matched)
            console.log(res.matched)
            setReportData(responseData);
        } catch (error) {
            Swal.fire("Error", error.response?.data?.message || "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const renderTableContent = () => {
        if (requestType === "mrv") {
            return (
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Request No.</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Apporved Qty</th>
                        <th>Casting Qty</th>
                        <th>Qty After Casting</th>
                        <th>Unit</th>
                    </tr>
                </thead>
            );
        } else {
            return (
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Request No.</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Apporved Qty</th>
                        <th>Casting Qty</th>
                        <th>Qty After Casting</th>
                        <th>Unit</th>
                    </tr>
                </thead>
            );
        }
    };

    const handlePrint = () => {
        const items = reportData;
        const documentUser = { user: { name: "Store Staff" } };

        const generateHTML = () => {

            // ==========================================
            // CURRENT LOGGED-IN USER FOR PRINT FOOTER
            // ==========================================

            const loggedInUser =
                JSON.parse(
                    localStorage.getItem("userDetails")
                );

            const printedBy =
                loggedInUser?.data?.user?.name
                    ? String(
                        loggedInUser.data.user.name
                    ).toUpperCase()
                    : "N/A";


            // ==========================================
            // CURRENT PRINT DATE + TIME
            // DD-MM-YYYY HH:MM:SS
            // ==========================================

            const getPrintDateTime = () => {

                const now = new Date();

                const dd =
                    String(
                        now.getDate()
                    ).padStart(2, "0");

                const mm =
                    String(
                        now.getMonth() + 1
                    ).padStart(2, "0");

                const yyyy =
                    now.getFullYear();

                const hh =
                    String(
                        now.getHours()
                    ).padStart(2, "0");

                const min =
                    String(
                        now.getMinutes()
                    ).padStart(2, "0");

                const ss =
                    String(
                        now.getSeconds()
                    ).padStart(2, "0");

                return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
            };


            // ==========================================
            // SAFE DATE FORMAT
            // DD/MM/YYYY
            // ==========================================

            const formatCastingDate = (date) => {

                if (!date) {
                    return "N/A";
                }

                return new Date(
                    date
                ).toLocaleDateString(
                    "en-GB"
                );
            };


            // ==========================================
            // MRV CASTING PRINT
            // ==========================================

            if (requestType === "mrv") {

                return `

<div
    style="
        max-width:1024px;
        margin:0 auto;
        background-color:white;
        padding:24px;
        border:1px solid #d1d5db;
    "
>

    <!-- ==========================================
         HEADER
    =========================================== -->

    <div
        style="
            display:flex;
            justify-content:space-between;
            align-items:flex-start;
            margin-bottom:16px;
        "
    >

        <!-- COMPANY -->

        <div>

            <h1
                style="
                    font-size:1.1rem;
                    font-weight:600;
                    margin:0 0 4px 0;
                "
            >
                Indigo Infraprojects Pvt. Ltd.
            </h1>

            <p
                style="
                    margin:2px 0;
                    font-size:10px;
                "
            >
                3rd Floor, Plot No. - 12/B,
                Pocket 3, Sector - 17, Dwarka
            </p>

            <p
                style="
                    margin:2px 0;
                    font-size:10px;
                "
            >
                New Delhi - 110 075
            </p>

            <p
                style="
                    margin:2px 0;
                    font-size:10px;
                "
            >
                Ph : +91-11-4572 0741, 4445 8664
            </p>

        </div>


        <!-- LOGO -->

        <div>

            <img
                src="https://indigoinfra.in/img/product/product-1739471679615.jpeg"
                alt="Company Logo"
                style="
                    height:3rem;
                "
            />

        </div>

    </div>


    <!-- ==========================================
         TITLE
    =========================================== -->

    <h2
        style="
            text-align:center;
            font-size:1rem;
            font-weight:600;
            margin:0 0 1rem 0;
            text-transform:uppercase;
        "
    >
        MATERIAL RECEIPT VOUCHER (CASTING)
    </h2>

    <div
        style="
            text-align:center;
            font-size:10px;
            font-weight:600;
            margin-bottom:20px;
        "
    >
        DIGITAL COPY
    </div>


    <!-- ==========================================
         MRV DETAILS
    =========================================== -->

    <div
    style="
        display:flex;
        justify-content:space-between;
        align-items:flex-start;

        width:100%;

        margin-top:20px;
        margin-bottom:24px;

        padding-top:6px;
        padding-bottom:6px;

        font-size:10px;
        font-weight:400;
        line-height:1.6;
    "
>

       <!-- LEFT -->

<div
    style="
        width:48%;
        text-align:left;
    "
>

            <p style="margin:3px 0;">
                MRV No. :
                <strong>
                    ${headindData?.RequestNo || "N/A"}
                </strong>
            </p>

            <p style="margin:3px 0;">
                Supplier Name :
                <strong>
                    ........................................
                </strong>
            </p>

            <p style="margin:3px 0;">
                Bill No. / DC No. :
                <strong>
                    ........................................
                </strong>
            </p>

        </div>


        <!-- RIGHT -->

<div
    style="
        width:48%;
        text-align:left;
       padding-left:25%;
    "
>

            <p style="margin:3px 0;">
                Project Code :
                <strong>
                    ${headindData?.inventory?.store?.storeCode ||
                    headindData?.projectCode ||
                    "N/A"
                    }
                </strong>
            </p>

            <p style="margin:3px 0;">
                Project Name :
                <strong>
                    ${headindData?.inventory?.store?.name ||
                    headindData?.storeName ||
                    "N/A"
                    }
                </strong>
            </p>

            <p style="margin:3px 0;">
                Location :
                <strong>
                    ${headindData?.inventory?.store?.location ||
                    "N/A"
                    }
                </strong>
            </p>

            <p style="margin:3px 0;">
                Casting Date :
                <strong>
                    ${formatCastingDate(
                        headindData?.castingRequestDate ||
                        headindData?.createdAt
                    )
                    }
                </strong>
            </p>

        </div>

    </div>


    <!-- ==========================================
         TABLE
    =========================================== -->

    <table
        style="
            width:100%;
            border-collapse:collapse;
            border:1px solid #cbd5e0;
            margin-bottom:16px;
            font-size:11px;
            line-height:1.35;
            text-align:left;
        "
    >

        <thead>

            <tr>

                <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
                    S.No
                </th>

                <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
                    Request No.
                </th>

                <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
                    Part No
                </th>

                <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
                    Description
                </th>

                <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
                    Qty Approved
                </th>

                <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
                    Casting Qty
                </th>

                <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
                    Final Qty After Casting
                </th>

                <th style="border:1px solid #cbd5e0; padding:8px; font-weight:700;">
                    Unit
                </th>

            </tr>

        </thead>


        <tbody>

            ${reportData.map((item, index) => `

                <tr>

                    <td style="border:1px solid #cbd5e0; padding:8px;">
                        ${index + 1}
                    </td>

                    <td style="border:1px solid #cbd5e0; padding:8px;">
                        ${headindData?.RequestNo || "N/A"}
                    </td>

                    <td style="border:1px solid #cbd5e0; padding:8px;">
                        ${item?.masterItem?.partNo || "N/A"}
                    </td>

                    <td style="border:1px solid #cbd5e0; padding:8px;">
                        ${item?.masterItem?.description || "N/A"}
                    </td>

                    <td style="border:1px solid #cbd5e0; padding:8px;">
                        ${item?.approveQty ?? 0}
                    </td>

                    <td style="border:1px solid #cbd5e0; padding:8px;">
                        ${item?.castingQty ?? 0}
                    </td>

                    <td style="border:1px solid #cbd5e0; padding:8px;">
                        ${Math.max(
                        0,
                        (Number(item?.approveQty) || 0) +
                        (Number(item?.castingQty) || 0)
                    )
                        }
                    </td>

                    <td style="border:1px solid #cbd5e0; padding:8px;">
                        ${item?.unitName || "N/A"}
                    </td>

                </tr>

            `).join("")}

        </tbody>

    </table>


    <!-- ==========================================
         MRV CASTING INFORMATION FOOTER
    =========================================== -->

    <div
        style="
            margin-top:22px;
            padding-top:7px;
            border-top:1px solid #a0aec0;

            display:flex;
            justify-content:space-between;
            align-items:center;

            width:100%;

            font-size:7px;
            font-weight:400;
            color:#718096;

            text-transform:uppercase;
            letter-spacing:0.1px;
            line-height:1.2;
        "
    >

        <!-- LEFT -->

        <div
            style="
                width:33%;
                text-align:left;
            "
        >

            <strong
                style="
                    font-size:7px;
                    font-weight:600;
                "
            >
                CASTING REQUEST NO:
                ${headindData?.RequestNo || "N/A"}
            </strong>

        </div>


        <!-- CENTER -->

        <div
            style="
                width:34%;
                text-align:center;
            "
        >

            PRINTED BY:

            <strong
                style="
                    font-size:7px;
                    font-weight:600;
                "
            >
                ${printedBy}
            </strong>

            (${getPrintDateTime()})

        </div>


        <!-- RIGHT -->

        <div
            style="
                width:33%;
                text-align:right;
            "
        >

            <strong
                style="
                    font-size:7px;
                    font-weight:600;
                "
            >
                DIGITAL COPY
            </strong>

        </div>

    </div>

</div>

`;

            }


            // ==========================================
            // MIV CASTING PRINT
            // ==========================================

            return `

<div
    style="
        max-width:64rem;
        margin:0 auto;
        background-color:white;
        padding:1.5rem;
        border:1px solid #d1d5db;
    "
>

    <!-- ==========================================
         HEADER
    =========================================== -->

    <div
        style="
            display:flex;
            justify-content:space-between;
            align-items:flex-start;
            margin-bottom:1rem;
        "
    >

        <!-- COMPANY -->

        <div>

            <h1
                style="
                    font-size:1.1rem;
                    font-weight:600;
                    margin:0 0 4px 0;
                "
            >
                Indigo Infraprojects Pvt. Ltd.
            </h1>

            <p
                style="
                    margin:2px 0;
                    font-size:10px;
                    font-weight:400;
                "
            >
                3rd Floor, Plot No. - 12/B,
                Pocket 3, Sector - 17, Dwarka
            </p>

            <p
                style="
                    margin:2px 0;
                    font-size:10px;
                    font-weight:400;
                "
            >
                New Delhi - 110 075
            </p>

            <p
                style="
                    margin:2px 0;
                    font-size:10px;
                    font-weight:400;
                "
            >
                Ph : +91-11-4572 0741, 4445 8664
            </p>

        </div>


        <!-- LOGO -->

        <div>

            <img
                src="https://indigoinfra.in/img/product/product-1739471679615.jpeg"
                alt="Company Logo"
                style="
                    height:3rem;
                "
            />

        </div>

    </div>


    <!-- ==========================================
         TITLE
    =========================================== -->

    <h2
        style="
            text-align:center;
            font-size:1rem;
            font-weight:600;
            margin:0 0 4px 0;
            text-transform:uppercase;
        "
    >
        MATERIAL ISSUES VOUCHER (CASTING)
    </h2>

    <div
        style="
            text-align:center;
            font-size:10px;
            font-weight:600;
            margin-bottom:20px;
        "
    >
        DIGITAL COPY
    </div>


    <!-- ==========================================
         MIV DETAILS
    =========================================== -->

        <!-- ==========================================
         MIV DETAILS
    =========================================== -->

    <div
        style="
            display:flex;
            justify-content:space-between;
            align-items:flex-start;
            width:100%;

            margin-top:20px;
            margin-bottom:24px;

            padding-top:6px;
            padding-bottom:6px;

            font-size:10px;
            font-weight:400;
            line-height:1.6;
        "
    >

        <!-- LEFT : MIV DETAILS -->

        <div
            style="
                width:40%;
                text-align:left;
            "
        >

            <p style="margin:3px 0;">
                MIV No. :
                <strong>
                    ${headindData?.RequestNo || "N/A"}
                </strong>
            </p>

            <p style="margin:3px 0;">
                Machine :
                <strong>
                    ${headindData?.machine || "N/A"}
                </strong>
            </p>

            <p style="margin:3px 0;">
                MIV Date :
                <strong>
                    ${formatCastingDate(
                        headindData?.mivDate
                    )}
                </strong>
            </p>

            <p style="margin:3px 0;">
                Requested By :
                <strong>
                    ${headindData?.requestedBy ||
                    headindData?.user?.name ||
                    "N/A"}
                </strong>
            </p>

        </div>


        <!-- RIGHT : PROJECT DETAILS -->

        <div
            style="
                width:40%;
                margin-left:auto;
                text-align:left;
                padding-left:20%;
            "
        >

            <p style="margin:3px 0;">
                Project Code :
                <strong>
                    ${headindData?.inventory?.store?.storeCode ||
                    headindData?.projectCode ||
                    "N/A"}
                </strong>
            </p>

            <p style="margin:3px 0;">
                Project Name :
                <strong>
                    ${headindData?.inventory?.store?.name ||
                    headindData?.storeName ||
                    "N/A"}
                </strong>
            </p>

            <p style="margin:3px 0;">
                Location :
                <strong>
                    ${headindData?.inventory?.store?.location ||
                    headindData?.location ||
                    "N/A"}
                </strong>
            </p>

            <p style="margin:3px 0;">
                Casting Date :
                <strong>
                    ${formatCastingDate(
                        headindData?.castingRequestDate ||
                        headindData?.createdAt
                    )}
                </strong>
            </p>

        </div>

    </div>


    <!-- ==========================================
         ITEMS TABLE
    =========================================== -->

    <table
        style="
            width:100%;
            border-collapse:collapse;
            border:1px solid #cbd5e0;
            margin-bottom:16px;

            font-size:11px;
            line-height:1.35;
            text-align:left;
        "
    >

        <thead>

            <tr>

                <th
                    style="
                        border:1px solid #cbd5e0;
                        padding:8px;
                        font-weight:700;
                    "
                >
                    S.No
                </th>


                <th
                    style="
                        border:1px solid #cbd5e0;
                        padding:8px;
                        font-weight:700;
                    "
                >
                    Part No
                </th>


                <th
                    style="
                        border:1px solid #cbd5e0;
                        padding:8px;
                        font-weight:700;
                    "
                >
                    Description
                </th>


                <th
                    style="
                        border:1px solid #cbd5e0;
                        padding:8px;
                        font-weight:700;
                    "
                >
                    Qty Approved
                </th>


                <th
                    style="
                        border:1px solid #cbd5e0;
                        padding:8px;
                        font-weight:700;
                    "
                >
                    Casting Qty
                </th>


                <th
                    style="
                        border:1px solid #cbd5e0;
                        padding:8px;
                        font-weight:700;
                    "
                >
                    Qty After Casting
                </th>


                <th
                    style="
                        border:1px solid #cbd5e0;
                        padding:8px;
                        font-weight:700;
                    "
                >
                    Unit
                </th>

            </tr>

        </thead>


        <tbody>

            ${reportData.map((item, index) => `

                <tr>

                    <td
                        style="
                            border:1px solid #cbd5e0;
                            padding:8px;
                        "
                    >
                        ${index + 1}
                    </td>


                    <td
                        style="
                            border:1px solid #cbd5e0;
                            padding:8px;
                            white-space:nowrap;
                        "
                    >
                        ${item?.masterItem?.partNo ||
                    item?.partNo ||
                    "N/A"
                    }
                    </td>


                    <td
                        style="
                            border:1px solid #cbd5e0;
                            padding:8px;
                        "
                    >
                        ${item?.masterItem?.description ||
                    item?.description ||
                    "N/A"
                    }
                    </td>


                    <td
                        style="
                            border:1px solid #cbd5e0;
                            padding:8px;
                        "
                    >
                        ${item?.approveQty ?? 0}
                    </td>


                    <td
                        style="
                            border:1px solid #cbd5e0;
                            padding:8px;
                        "
                    >
                        ${item?.castingQty ?? 0}
                    </td>


                    <td
                        style="
                            border:1px solid #cbd5e0;
                            padding:8px;
                        "
                    >

                        ${Math.max(
                        0,
                        (Number(item?.approveQty) || 0) +
                        (Number(item?.castingQty) || 0)
                    )
                    }

                    </td>


                    <td
                        style="
                            border:1px solid #cbd5e0;
                            padding:8px;
                            white-space:nowrap;
                        "
                    >
                        ${item?.unitName ||
                    item?.masterItem?.unitName ||
                    "N/A"
                    }
                    </td>

                </tr>

            `).join("")}

        </tbody>

    </table>


    <!-- ==========================================
         SIGNATURE SECTION
    =========================================== -->

    <div
        style="
            display:flex;
            justify-content:space-between;
            align-items:flex-start;

            width:100%;

            margin-top:28px;
            margin-bottom:18px;

            font-size:10px;
            font-family:Arial, sans-serif;
        "
    >

        <!-- LEFT -->

        <div
            style="
                width:33%;
                text-align:left;
            "
        >

            <div
                style="
                    border-top:1px solid #000;
                    padding-top:4px;
                    width:140px;
                "
            >
                Approved By
            </div>

            <strong>
                ${headindData?.user?.name
                    ? String(
                        headindData.user.name
                    ).toUpperCase()
                    : "N/A"
                }
            </strong>

        </div>


        <!-- CENTER -->

        <div
            style="
                width:34%;
                text-align:center;
            "
        >

            <div
                style="
                    border-top:1px solid #000;
                    padding-top:4px;
                    width:140px;
                    margin:0 auto;
                "
            >
                Stores Officer
            </div>

        </div>


        <!-- RIGHT -->

        <div
            style="
                width:33%;
                text-align:right;
            "
        >

            <div
                style="
                    border-top:1px solid #000;
                    padding-top:4px;
                    width:140px;
                    margin-left:auto;
                "
            >
                Received By
            </div>

        </div>

    </div>


    <!-- ==========================================
         CASTING INFORMATION FOOTER
    =========================================== -->

    <div
        style="
            margin-top:22px;
            padding-top:7px;
            border-top:1px solid #a0aec0;

            display:flex;
            justify-content:space-between;
            align-items:center;

            width:100%;

            font-size:7px;
            font-weight:400;
            color:#718096;

            text-transform:uppercase;
            letter-spacing:0.1px;
            line-height:1.2;
        "
    >

        <!-- LEFT : CASTING REQUEST NUMBER -->

        <div
            style="
                width:33%;
                text-align:left;
            "
        >

            <strong
                style="
                    font-size:7px;
                    font-weight:600;
                "
            >
                CASTING REQUEST NO:
                ${headindData?.RequestNo || "N/A"}
            </strong>

        </div>


        <!-- CENTER : PRINTED BY + DATE TIME -->

        <div
            style="
                width:34%;
                text-align:center;
            "
        >

            PRINTED BY:

            <strong
                style="
                    font-size:7px;
                    font-weight:600;
                "
            >
                ${printedBy}
            </strong>

            (${getPrintDateTime()})

        </div>


        <!-- RIGHT : DIGITAL COPY -->

        <div
            style="
                width:33%;
                text-align:right;
            "
        >

            <strong
                style="
                    font-size:7px;
                    font-weight:600;
                "
            >
                DIGITAL COPY
            </strong>

        </div>

    </div>

</div>

`;
        };


        // ==========================================
        // COMPLETE PRINT HTML
        // ==========================================

        const htmlContent = `

<html lang="en">

<head>

    <meta charset="utf-8"/>

    <meta
        content="width=device-width, initial-scale=1.0"
        name="viewport"
    />

    <title>
        Print ${requestType.toUpperCase()}
    </title>

    <style>

        * {
            box-sizing: border-box;
        }

        html,
        body {
            margin: 0;
            padding: 0;
        }

        body {
            background-color: #f3f4f6;
            padding: 1rem;
            font-family: Arial, sans-serif;
            color: #000;
        }

        table {
            page-break-inside: auto;
        }

        tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }

        thead {
            display: table-header-group;
        }

        @media print {

            @page {
                size: A4 landscape;
                margin: 10mm;
            }

            html,
            body {
                background: #ffffff !important;
                padding: 0 !important;
                margin: 0 !important;
            }

            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }

        }

    </style>

</head>


<body>

    ${generateHTML()}

</body>

</html>

`;

        const newWindow = window.open("", "_blank");
        newWindow.document.write(htmlContent);
        newWindow.document.close();
        newWindow.focus();
        newWindow.print();
    };

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="filter cm-content-box box-primary">
                    <div className="content-title">
                        <div className="cpa">
                            <i className="fas fa-filter me-2"></i>Filter
                        </div>
                        <div className="tools">
                            <Link
                                to="#"
                                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                onClick={() => setOpen(!open)}
                            >
                                <i className={`fas ${open ? "fa-angle-down" : "fa-angle-up"}`}></i>
                            </Link>
                        </div>
                    </div>

                    <Collapse in={open}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Enter Form Number</label>
                                        <input
                                            type="number"
                                            className="form-control mb-xxl-0 mb-3"
                                            placeholder="Enter Form Number"
                                            value={formNumber}
                                            onChange={(e) => setFormNumber(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Select Request Type</label>
                                        <select
                                            className="form-select"
                                            style={{ height: "55px" }}
                                            value={requestType}
                                            onChange={(e) => setRequestType(e.target.value)}
                                        >
                                            <option value="mrv">Material Receipt Voucher (MRV)</option>
                                            <option value="miv">Material Issue Voucher (MIV)</option>
                                        </select>
                                    </div>

                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Search</label>
                                        <button
                                            className="form-control btn btn-primary"
                                            onClick={handleSearch}
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Search"}
                                        </button>
                                    </div>

                                    <div className="col-xl-3 col-xxl-3 mt-4">
                                        <button
                                            className="btn btn-success w-100"
                                            onClick={handlePrint}
                                            disabled={reportData.length === 0}
                                        >
                                            Print
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>

                <div className="filter cm-content-box box-primary mt-1">
                    <div className="content-title">
                        <div className="cpa">
                            <i className="fa fa-list me-2" aria-hidden="true"></i>
                            {requestType === "miv" ? "MIV" : "MRV"}{" "}
                            <span className="badge bg-orange ms-2">{reportData.length}</span>
                        </div>
                        <div className="tools">
                            <Link
                                to="#"
                                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                onClick={() => setOpen2(!open2)}
                            >
                                <i className={`fas ${open2 ? "fa-angle-down" : "fa-angle-up"}`}></i>
                            </Link>
                        </div>
                    </div>

                    <Collapse in={open2}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped">
                                        {renderTableContent()}

                                        <tbody>
                                            {reportData.length > 0 ? (
                                                reportData.map((item, index) => {
                                                    const approved = Number(item?.approveQty) || 0;
                                                    const casting = Number(item?.castingQty) || 0;

                                                    const finalQty = Math.max(0, approved + casting);

                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item?.RequestNo}</td>
                                                            <td>{item?.masterItem?.partNo || ""}</td>
                                                            <td>{item?.masterItem?.description || ""}</td>
                                                            <td>{item?.approveQty}</td>
                                                            <td>{item?.castingQty}</td>
                                                            <td>{finalQty}</td>
                                                            <td>{item?.masterItem?.unit?.name || ""}</td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
        </div>
    );

};

export default CastingDigital;
